// extracted by mini-css-extract-plugin
export default {"AppGroupsHeader":"AppGroups_AppGroupsHeader__Tliax","AppGroupsBackButton":"AppGroups_AppGroupsBackButton__YjflE"};